import { fetchSameOrigin } from '../Utils';

const deleteCarePlan = (memberId, planId) => {
  const url = `/members/${memberId}/care_plans/${planId}`;
  return fetchSameOrigin(url, 'DELETE', { })
    .then(r => r.json()).then( ({ data })=> {
      window.location.reload();
  })
};

export default deleteCarePlan;
